import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HandSoap } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { ShareBar } from "@/components/ShareBar";

/** The pinned house notice, echoed on the other public boards. */
export const PinnedNotice = ({ testid = "pinned-notice" }) => {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    api.get("/facilities/public").then(({ data }) => setNotice(data.pinned)).catch(() => setNotice(null));
  }, []);

  if (!notice) return null;

  return (
    <section className="mt-10 border-l-4 border-[#0B5C2E] bg-white p-5" data-testid={testid}>
      <p className="overline text-[#0B5C2E]">
        <HandSoap size={14} className="mr-1 inline align-[-2px]" />House rule · every day
      </p>
      <p className="font-display mt-1 text-2xl font-bold uppercase tracking-tight text-[#0F172A]">
        {notice.heading}
      </p>
      <div className="mt-2 space-y-1">
        {(notice.lines || []).map((line, i) => (
          <p key={i} className={i === 0 ? "text-base font-semibold text-[#0F172A]" : "text-sm text-slate-700"}>
            {line}
          </p>
        ))}
      </div>
      {notice.note && <p className="mt-2 text-sm text-slate-600">{notice.note}</p>}
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <Link to="/notices" data-testid={`${testid}-link`}
          className="tap-safe text-sm font-semibold text-[#002FA7] hover:underline">
          All the house notices
        </Link>
        <ShareBar url={`${window.location.origin}/notices`}
          text={`${notice.heading} — ${(notice.lines || []).join(" ")}`}
          testid={`${testid}-share`} compact instagram />
      </div>
    </section>
  );
};
